import { render } from "./DestinationDashboard.vue?vue&type=template&id=1dcf4e61"
import script from "./DestinationDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./DestinationDashboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Destination/DestinationDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1dcf4e61"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1dcf4e61', __exports__)) {
    api.reload('1dcf4e61', __exports__)
  }
  
  module.hot.accept("./DestinationDashboard.vue?vue&type=template&id=1dcf4e61", () => {
    api.rerender('1dcf4e61', render)
  })

}


export default __exports__